import { useRef } from 'react'

export const useFocus = () => {
  const htmlElRef = useRef<HTMLElement>()

  const setFocus = () => {
    const currentEl = htmlElRef.current
    return currentEl && currentEl.focus()
  }

  return [htmlElRef, setFocus] as const
}

export default useFocus
